import type { TrackingEventResponse } from '../../api/types';
import { shipmentStatusLabel } from './shipmentStatusLabel';

/** Contract value for the LOADED milestone the API writes on document approval (rhino-api#305). */
export const TRACKING_SOURCE_DOCUMENT_APPROVAL = 'DOCUMENT_APPROVAL';

function isAutoLoaded(t: TrackingEventResponse): boolean {
  return (
    t.isManualMilestone &&
    t.milestoneStatus === 'LOADED' &&
    t.source === TRACKING_SOURCE_DOCUMENT_APPROVAL
  );
}

/**
 * Title of a Milestone Timeline row: a milestone reads as its shared status label ("In transit",
 * never the raw code or a "(Milestone)" suffix, #323); a ping is a "Location Ping".
 */
export function trackingEventTitle(t: TrackingEventResponse): string {
  if (isAutoLoaded(t)) return shipmentStatusLabel('LOADED');
  return t.isManualMilestone ? shipmentStatusLabel(t.milestoneStatus) : 'Location Ping';
}

/** Secondary line saying how the milestone was set; `null` (no line) for null or unknown sources. */
export function trackingEventSourceNote(t: TrackingEventResponse): string | null {
  return t.source === TRACKING_SOURCE_DOCUMENT_APPROVAL ? 'Auto on document approval' : null;
}
